import * as React from "react";
// import TitleImage from './image.png'
const isMobile = window.innerWidth <= 768

const SVGComponent = ({ TitleImage, poemImageUrl, ...props }) => (
  <svg
    width={isMobile ? "100%" : "115%"}
    height={isMobile ? 510 : 574}
    viewBox={isMobile ? "0 0 432 510" : "0 0 432 574"}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <rect width={419.669} height={424} fill="#FFFFFF" />
    <rect
      x={57}
      y={380}
      width={374.471}
      height={194}
      fill="#FFFFFF"
    />
    {TitleImage ? (
      <image
        x={isMobile ? 30 : 0}
        y={0}
        width={isMobile ? 319.669 : 419.669}
        height={isMobile ? 304 : 354}
        preserveAspectRatio="none"
        href={TitleImage}
        xlinkHref={TitleImage}
      />
    ) : null}
    {poemImageUrl ? (
      <image
        x={isMobile ? 56 : 35}
        y={isMobile ? 270 : 310}
        width={isMobile ? 380 : 374.471}
        height={isMobile ? 170 : 194}
        preserveAspectRatio="none"
        href={poemImageUrl}
        xlinkHref={poemImageUrl}
      />
    ) : null}
    <defs>
      <image
        id="image0_81_2"
        width={969}
        height={979}
        preserveAspectRatio="none"
        href={TitleImage}
        xlinkHref={TitleImage}
      />
      <image
        id="image1_81_2"
        width={1550}
        height={803}
        preserveAspectRatio="none"
        href={poemImageUrl}
        xlinkHref={poemImageUrl}
      />
    </defs>
  </svg>
);
export default SVGComponent;
